// @generated by bzl gen
// @generated by protoc-gen-es v0.2.1 with parameter "target=ts"
// @generated from file dropbox/proto/context_engine/conversations.proto (package context_engine, syntax proto3)
/* eslint-disable */
/* @ts-nocheck */

import type {
  BinaryReadOptions,
  FieldList,
  JsonReadOptions,
  JsonValue,
  PartialMessage,
  PlainMessage,
} from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import {
  DocumentContextProto,
  DocumentInfo,
  HandlerExperimentationConfigProto,
} from "./models_pb";

/**
 * @generated from enum context_engine.ResponseFormat
 */
export enum ResponseFormat {
  /**
   * @generated from enum value: MARKDOWN = 0;
   */
  MARKDOWN = 0,

  /**
   * @generated from enum value: JSON = 1;
   */
  JSON = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(ResponseFormat)
proto3.util.setEnumType(ResponseFormat, "context_engine.ResponseFormat", [
  { no: 0, name: "MARKDOWN" },
  { no: 1, name: "JSON" },
]);

/**
 * @generated from enum context_engine.ProgressUpdateStep
 */
export enum ProgressUpdateStep {
  /**
   * @generated from enum value: STEP_SEARCH = 0;
   */
  STEP_SEARCH = 0,

  /**
   * @generated from enum value: STEP_CONTEXT_SELECTION = 1;
   */
  STEP_CONTEXT_SELECTION = 1,

  /**
   * @generated from enum value: STEP_RESPONSE_GENERATION_FROM_LLM = 2;
   */
  STEP_RESPONSE_GENERATION_FROM_LLM = 2,

  /**
   * @generated from enum value: STEP_RESPONSE_GENERATION_FROM_AGENT = 3;
   */
  STEP_RESPONSE_GENERATION_FROM_AGENT = 3,

  /**
   * @generated from enum value: STEP_SUGGESTED_QUERIES_GENERATION = 4;
   */
  STEP_SUGGESTED_QUERIES_GENERATION = 4,

  /**
   * @generated from enum value: STEP_INTENT_DETECTION = 5;
   */
  STEP_INTENT_DETECTION = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ProgressUpdateStep)
proto3.util.setEnumType(
  ProgressUpdateStep,
  "context_engine.ProgressUpdateStep",
  [
    { no: 0, name: "STEP_SEARCH" },
    { no: 1, name: "STEP_CONTEXT_SELECTION" },
    { no: 2, name: "STEP_RESPONSE_GENERATION_FROM_LLM" },
    { no: 3, name: "STEP_RESPONSE_GENERATION_FROM_AGENT" },
    { no: 4, name: "STEP_SUGGESTED_QUERIES_GENERATION" },
    { no: 5, name: "STEP_INTENT_DETECTION" },
  ],
);

/**
 * @generated from enum context_engine.ConversationsAgent
 */
export enum ConversationsAgent {
  /**
   * @generated from enum value: UNKNOWN_AGENT = 0;
   */
  UNKNOWN_AGENT = 0,

  /**
   * @generated from enum value: STACK_INSIGHTS = 1;
   */
  STACK_INSIGHTS = 1,

  /**
   * @generated from enum value: WRITE = 2;
   */
  WRITE = 2,

  /**
   * @generated from enum value: CONVERSATION = 3;
   */
  CONVERSATION = 3,

  /**
   * @generated from enum value: SUMMARIZE = 4;
   */
  SUMMARIZE = 4,

  /**
   * @generated from enum value: FIND = 5;
   */
  FIND = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ConversationsAgent)
proto3.util.setEnumType(
  ConversationsAgent,
  "context_engine.ConversationsAgent",
  [
    { no: 0, name: "UNKNOWN_AGENT" },
    { no: 1, name: "STACK_INSIGHTS" },
    { no: 2, name: "WRITE" },
    { no: 3, name: "CONVERSATION" },
    { no: 4, name: "SUMMARIZE" },
    { no: 5, name: "FIND" },
  ],
);

/**
 * @generated from enum context_engine.ModelSource
 */
export enum ModelSource {
  /**
   * @generated from enum value: MODEL_SOURCE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: MODEL_SOURCE_DROPBOX = 1;
   */
  DROPBOX = 1,

  /**
   * @generated from enum value: MODEL_SOURCE_OPENAI = 2;
   */
  OPENAI = 2,

  /**
   * @generated from enum value: MODEL_SOURCE_GROQ = 3;
   */
  GROQ = 3,

  /**
   * @generated from enum value: MODEL_SOURCE_BEDROCK = 4;
   */
  BEDROCK = 4,

  /**
   * @generated from enum value: MODEL_SOURCE_VERTEX_AI = 5;
   */
  VERTEX_AI = 5,

  /**
   * @generated from enum value: MODEL_SOURCE_AZURE = 6;
   */
  AZURE = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(ModelSource)
proto3.util.setEnumType(ModelSource, "context_engine.ModelSource", [
  { no: 0, name: "MODEL_SOURCE_UNKNOWN" },
  { no: 1, name: "MODEL_SOURCE_DROPBOX" },
  { no: 2, name: "MODEL_SOURCE_OPENAI" },
  { no: 3, name: "MODEL_SOURCE_GROQ" },
  { no: 4, name: "MODEL_SOURCE_BEDROCK" },
  { no: 5, name: "MODEL_SOURCE_VERTEX_AI" },
  { no: 6, name: "MODEL_SOURCE_AZURE" },
]);

/**
 * @generated from message context_engine.WriteDraft
 */
export class WriteDraft extends Message<WriteDraft> {
  /**
   * Latest draft content
   *
   * @generated from field: string content = 1;
   */
  content = "";

  /**
   * opaque payload blob consumable by Write agent
   *
   * @generated from field: string write_agent_payload = 2;
   */
  writeAgentPayload = "";

  constructor(data?: PartialMessage<WriteDraft>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.WriteDraft";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "write_agent_payload",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): WriteDraft {
    return new WriteDraft().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): WriteDraft {
    return new WriteDraft().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): WriteDraft {
    return new WriteDraft().fromJsonString(jsonString, options);
  }

  static equals(
    a: WriteDraft | PlainMessage<WriteDraft> | undefined,
    b: WriteDraft | PlainMessage<WriteDraft> | undefined,
  ): boolean {
    return proto3.util.equals(WriteDraft, a, b);
  }
}

/**
 * @generated from message context_engine.ProgressUpdate
 */
export class ProgressUpdate extends Message<ProgressUpdate> {
  /**
   * @generated from field: context_engine.ProgressUpdateStep step = 1;
   */
  step = ProgressUpdateStep.STEP_SEARCH;

  /**
   * @generated from field: repeated context_engine.DocumentInfo context = 2;
   */
  context: DocumentInfo[] = [];

  /**
   * @generated from field: string agent_id = 3;
   */
  agentId = "";

  constructor(data?: PartialMessage<ProgressUpdate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ProgressUpdate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "step",
      kind: "enum",
      T: proto3.getEnumType(ProgressUpdateStep),
    },
    {
      no: 2,
      name: "context",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    { no: 3, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ProgressUpdate {
    return new ProgressUpdate().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ProgressUpdate {
    return new ProgressUpdate().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ProgressUpdate {
    return new ProgressUpdate().fromJsonString(jsonString, options);
  }

  static equals(
    a: ProgressUpdate | PlainMessage<ProgressUpdate> | undefined,
    b: ProgressUpdate | PlainMessage<ProgressUpdate> | undefined,
  ): boolean {
    return proto3.util.equals(ProgressUpdate, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsSystemMessage
 */
export class ConversationsSystemMessage extends Message<ConversationsSystemMessage> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  constructor(data?: PartialMessage<ConversationsSystemMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsSystemMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsSystemMessage {
    return new ConversationsSystemMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsSystemMessage {
    return new ConversationsSystemMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsSystemMessage {
    return new ConversationsSystemMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ConversationsSystemMessage
      | PlainMessage<ConversationsSystemMessage>
      | undefined,
    b:
      | ConversationsSystemMessage
      | PlainMessage<ConversationsSystemMessage>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsSystemMessage, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsUserMessage
 */
export class ConversationsUserMessage extends Message<ConversationsUserMessage> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  /**
   * @generated from field: string rephrased = 2;
   */
  rephrased = "";

  /**
   * Optional input document context provided by the client.
   * For server-accessible documents, these objects only need to contain uuids.
   * For client-local documents, these objects can also contain document content.
   *
   * @generated from field: repeated context_engine.DocumentInfo attachments = 3;
   */
  attachments: DocumentInfo[] = [];

  /**
   * to trigger pre-defined agents, e.g summarize
   *
   * @generated from field: repeated string agent_ids = 4;
   */
  agentIds: string[] = [];

  /**
   * optional opaque payload blob passed from client to agent
   *
   * @generated from field: string agent_payload = 5;
   */
  agentPayload = "";

  /**
   * true for user-visible informational messages that should not be used for response generation
   *
   * @generated from field: bool llm_ignore = 6;
   */
  llmIgnore = false;

  /**
   * Used to scope fss search conversations to a specific path in the fss. Default is empty
   *
   * @generated from field: string fss_search_scope = 7;
   */
  fssSearchScope = "";

  constructor(data?: PartialMessage<ConversationsUserMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsUserMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rephrased", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 3,
      name: "attachments",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    {
      no: 4,
      name: "agent_ids",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 5,
      name: "agent_payload",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 6, name: "llm_ignore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 7,
      name: "fss_search_scope",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsUserMessage {
    return new ConversationsUserMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsUserMessage {
    return new ConversationsUserMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsUserMessage {
    return new ConversationsUserMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ConversationsUserMessage
      | PlainMessage<ConversationsUserMessage>
      | undefined,
    b:
      | ConversationsUserMessage
      | PlainMessage<ConversationsUserMessage>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsUserMessage, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsToolCall
 */
export class ConversationsToolCall extends Message<ConversationsToolCall> {
  /**
   * The ID of the tool call
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * The name of the tool to be called
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * The arguments to call the tool with, as generated by the model in JSON format.
   * Note that the model does not always generate valid JSON, and may hallucinate parameters not
   * defined by your function schema. Validate the arguments in your code before calling your function.
   *
   * @generated from field: string arguments = 3;
   */
  arguments = "";

  /**
   * The type of the tool. Currently only `function` is supported.
   *
   * @generated from field: string type = 4;
   */
  type = "";

  constructor(data?: PartialMessage<ConversationsToolCall>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsToolCall";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "arguments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsToolCall {
    return new ConversationsToolCall().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsToolCall {
    return new ConversationsToolCall().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsToolCall {
    return new ConversationsToolCall().fromJsonString(jsonString, options);
  }

  static equals(
    a: ConversationsToolCall | PlainMessage<ConversationsToolCall> | undefined,
    b: ConversationsToolCall | PlainMessage<ConversationsToolCall> | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsToolCall, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsAssistantMessage
 */
export class ConversationsAssistantMessage extends Message<ConversationsAssistantMessage> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  /**
   * @generated from field: repeated context_engine.DocumentInfo cited = 2;
   */
  cited: DocumentInfo[] = [];

  /**
   * @generated from field: bool is_cached = 3;
   */
  isCached = false;

  /**
   * @generated from field: repeated context_engine.DocumentInfo context = 4;
   */
  context: DocumentInfo[] = [];

  /**
   * @generated from field: string agent_id = 5;
   */
  agentId = "";

  /**
   * @generated from field: context_engine.ResponseFormat format = 6;
   */
  format = ResponseFormat.MARKDOWN;

  /**
   * true for user-visible informational messages that should not be used for response generation
   *
   * @generated from field: bool llm_ignore = 7;
   */
  llmIgnore = false;

  /**
   * If provided, tool calls associated with the message.
   *
   * @generated from field: repeated context_engine.ConversationsToolCall tool_calls = 8;
   */
  toolCalls: ConversationsToolCall[] = [];

  constructor(data?: PartialMessage<ConversationsAssistantMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsAssistantMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cited", kind: "message", T: DocumentInfo, repeated: true },
    { no: 3, name: "is_cached", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 4,
      name: "context",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    { no: 5, name: "agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 6,
      name: "format",
      kind: "enum",
      T: proto3.getEnumType(ResponseFormat),
    },
    { no: 7, name: "llm_ignore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 8,
      name: "tool_calls",
      kind: "message",
      T: ConversationsToolCall,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsAssistantMessage {
    return new ConversationsAssistantMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsAssistantMessage {
    return new ConversationsAssistantMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsAssistantMessage {
    return new ConversationsAssistantMessage().fromJsonString(
      jsonString,
      options,
    );
  }

  static equals(
    a:
      | ConversationsAssistantMessage
      | PlainMessage<ConversationsAssistantMessage>
      | undefined,
    b:
      | ConversationsAssistantMessage
      | PlainMessage<ConversationsAssistantMessage>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsAssistantMessage, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsToolMessage
 */
export class ConversationsToolMessage extends Message<ConversationsToolMessage> {
  /**
   * @generated from field: string tool_call_id = 1;
   */
  toolCallId = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  /**
   * @generated from field: repeated string arguments = 4;
   */
  arguments: string[] = [];

  constructor(data?: PartialMessage<ConversationsToolMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsToolMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "tool_call_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 4,
      name: "arguments",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsToolMessage {
    return new ConversationsToolMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsToolMessage {
    return new ConversationsToolMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsToolMessage {
    return new ConversationsToolMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ConversationsToolMessage
      | PlainMessage<ConversationsToolMessage>
      | undefined,
    b:
      | ConversationsToolMessage
      | PlainMessage<ConversationsToolMessage>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsToolMessage, a, b);
  }
}

/**
 * @generated from message context_engine.ConversationsChatMessage
 */
export class ConversationsChatMessage extends Message<ConversationsChatMessage> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * @generated from oneof context_engine.ConversationsChatMessage.message_type
   */
  messageType:
    | {
        /**
         * @generated from field: context_engine.ConversationsSystemMessage system_message = 3;
         */
        value: ConversationsSystemMessage;
        case: "systemMessage";
      }
    | {
        /**
         * @generated from field: context_engine.ConversationsUserMessage user_message = 4;
         */
        value: ConversationsUserMessage;
        case: "userMessage";
      }
    | {
        /**
         * @generated from field: context_engine.ConversationsAssistantMessage assistant_message = 5;
         */
        value: ConversationsAssistantMessage;
        case: "assistantMessage";
      }
    | {
        /**
         * @generated from field: context_engine.ConversationsToolMessage tool_message = 7;
         */
        value: ConversationsToolMessage;
        case: "toolMessage";
      }
    | { case: undefined; value?: undefined } = { case: undefined };

  /**
   * @generated from field: string conversation_id = 6;
   */
  conversationId = "";

  /**
   * @generated from field: context_engine.EvalResponseData eval_data = 8;
   */
  evalData?: EvalResponseData;

  constructor(data?: PartialMessage<ConversationsChatMessage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ConversationsChatMessage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
    {
      no: 3,
      name: "system_message",
      kind: "message",
      T: ConversationsSystemMessage,
      oneof: "message_type",
    },
    {
      no: 4,
      name: "user_message",
      kind: "message",
      T: ConversationsUserMessage,
      oneof: "message_type",
    },
    {
      no: 5,
      name: "assistant_message",
      kind: "message",
      T: ConversationsAssistantMessage,
      oneof: "message_type",
    },
    {
      no: 7,
      name: "tool_message",
      kind: "message",
      T: ConversationsToolMessage,
      oneof: "message_type",
    },
    {
      no: 6,
      name: "conversation_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 8, name: "eval_data", kind: "message", T: EvalResponseData },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ConversationsChatMessage {
    return new ConversationsChatMessage().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ConversationsChatMessage {
    return new ConversationsChatMessage().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ConversationsChatMessage {
    return new ConversationsChatMessage().fromJsonString(jsonString, options);
  }

  static equals(
    a:
      | ConversationsChatMessage
      | PlainMessage<ConversationsChatMessage>
      | undefined,
    b:
      | ConversationsChatMessage
      | PlainMessage<ConversationsChatMessage>
      | undefined,
  ): boolean {
    return proto3.util.equals(ConversationsChatMessage, a, b);
  }
}

/**
 * @generated from message context_engine.SuggestedQuery
 */
export class SuggestedQuery extends Message<SuggestedQuery> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  /**
   * @generated from field: repeated string doc_ids = 2;
   */
  docIds: string[] = [];

  /**
   * @generated from field: context_engine.ConversationsAgent agent = 3;
   */
  agent = ConversationsAgent.UNKNOWN_AGENT;

  /**
   * @generated from field: bool is_static_suggestion = 4;
   */
  isStaticSuggestion = false;

  /**
   * A confidence score that can be used for ranking suggestions when needed.
   *
   * @generated from field: float score = 5;
   */
  score = 0;

  /**
   * A unique identifier for the prediction, used for ML logging.
   * So that we can join with user actions to identify if a suggestion was clicked or not.
   *
   * @generated from field: string prediction_id = 6;
   */
  predictionId = "";

  constructor(data?: PartialMessage<SuggestedQuery>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.SuggestedQuery";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "doc_ids",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
      repeated: true,
    },
    {
      no: 3,
      name: "agent",
      kind: "enum",
      T: proto3.getEnumType(ConversationsAgent),
    },
    {
      no: 4,
      name: "is_static_suggestion",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    { no: 5, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    {
      no: 6,
      name: "prediction_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): SuggestedQuery {
    return new SuggestedQuery().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): SuggestedQuery {
    return new SuggestedQuery().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): SuggestedQuery {
    return new SuggestedQuery().fromJsonString(jsonString, options);
  }

  static equals(
    a: SuggestedQuery | PlainMessage<SuggestedQuery> | undefined,
    b: SuggestedQuery | PlainMessage<SuggestedQuery> | undefined,
  ): boolean {
    return proto3.util.equals(SuggestedQuery, a, b);
  }
}

/**
 * Represents a model that is available for use in conversations
 *
 * @generated from message context_engine.ModelInfo
 */
export class ModelInfo extends Message<ModelInfo> {
  /**
   * an opaque identifier for the model, used for model lookup
   * this is often a combination of provider and model name: ex: "openai:gpt-4"
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Human-readable name of the model to display in UI. ex: gpt-4o (OpenAI), Pixtral (Groq)
   *
   * @generated from field: string display_name = 2;
   */
  displayName = "";

  /**
   * Brief description of the model's capabilities or recommended use cases
   *
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * Indicates whether the model is certified for use
   * Certified models have been evaluated for quality and accuracy
   * Non-certified models may be less reliable and should be considered experimental
   *
   * @generated from field: bool is_certified = 4;
   */
  isCertified = false;

  /**
   * The source of the model.
   *
   * @generated from field: context_engine.ModelSource model_source = 5;
   */
  modelSource = ModelSource.UNKNOWN;

  constructor(data?: PartialMessage<ModelInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ModelInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    {
      no: 2,
      name: "display_name",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 3,
      name: "description",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    { no: 4, name: "is_certified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    {
      no: 5,
      name: "model_source",
      kind: "enum",
      T: proto3.getEnumType(ModelSource),
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ModelInfo {
    return new ModelInfo().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ModelInfo {
    return new ModelInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ModelInfo {
    return new ModelInfo().fromJsonString(jsonString, options);
  }

  static equals(
    a: ModelInfo | PlainMessage<ModelInfo> | undefined,
    b: ModelInfo | PlainMessage<ModelInfo> | undefined,
  ): boolean {
    return proto3.util.equals(ModelInfo, a, b);
  }
}

/**
 * @generated from message context_engine.ToolCallDataForEval
 */
export class ToolCallDataForEval extends Message<ToolCallDataForEval> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string arguments = 2;
   */
  arguments = "";

  /**
   * @generated from field: string output = 3;
   */
  output = "";

  constructor(data?: PartialMessage<ToolCallDataForEval>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.ToolCallDataForEval";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "arguments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "output", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): ToolCallDataForEval {
    return new ToolCallDataForEval().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): ToolCallDataForEval {
    return new ToolCallDataForEval().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): ToolCallDataForEval {
    return new ToolCallDataForEval().fromJsonString(jsonString, options);
  }

  static equals(
    a: ToolCallDataForEval | PlainMessage<ToolCallDataForEval> | undefined,
    b: ToolCallDataForEval | PlainMessage<ToolCallDataForEval> | undefined,
  ): boolean {
    return proto3.util.equals(ToolCallDataForEval, a, b);
  }
}

/**
 * @generated from message context_engine.CitationForEval
 */
export class CitationForEval extends Message<CitationForEval> {
  /**
   * Document or message id
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Index in the context
   *
   * @generated from field: int32 index = 2;
   */
  index = 0;

  constructor(data?: PartialMessage<CitationForEval>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.CitationForEval";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): CitationForEval {
    return new CitationForEval().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): CitationForEval {
    return new CitationForEval().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): CitationForEval {
    return new CitationForEval().fromJsonString(jsonString, options);
  }

  static equals(
    a: CitationForEval | PlainMessage<CitationForEval> | undefined,
    b: CitationForEval | PlainMessage<CitationForEval> | undefined,
  ): boolean {
    return proto3.util.equals(CitationForEval, a, b);
  }
}

/**
 * @generated from message context_engine.EvalRequestParams
 */
export class EvalRequestParams extends Message<EvalRequestParams> {
  /**
   * Intentionally using a JSON string over the protobuf HandlerExperimentationConfigProto
   * to avoid accidentally overriding the config with default values when the proto is initialized.
   *
   * @generated from field: string override_experimentation_config_json_str = 1;
   */
  overrideExperimentationConfigJsonStr = "";

  constructor(data?: PartialMessage<EvalRequestParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.EvalRequestParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "override_experimentation_config_json_str",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): EvalRequestParams {
    return new EvalRequestParams().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): EvalRequestParams {
    return new EvalRequestParams().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): EvalRequestParams {
    return new EvalRequestParams().fromJsonString(jsonString, options);
  }

  static equals(
    a: EvalRequestParams | PlainMessage<EvalRequestParams> | undefined,
    b: EvalRequestParams | PlainMessage<EvalRequestParams> | undefined,
  ): boolean {
    return proto3.util.equals(EvalRequestParams, a, b);
  }
}

/**
 * @generated from message context_engine.EvalResponseData
 */
export class EvalResponseData extends Message<EvalResponseData> {
  /**
   * @generated from field: repeated context_engine.DocumentInfo matched_documents = 1;
   */
  matchedDocuments: DocumentInfo[] = [];

  /**
   * @generated from field: repeated context_engine.DocumentInfo matched_messages = 2;
   */
  matchedMessages: DocumentInfo[] = [];

  /**
   * @generated from field: context_engine.HandlerExperimentationConfigProto experiment_config = 3;
   */
  experimentConfig?: HandlerExperimentationConfigProto;

  /**
   * @generated from field: repeated context_engine.DocumentContextProto selected_context = 4;
   */
  selectedContext: DocumentContextProto[] = [];

  /**
   * @generated from field: string rephrased_query = 5;
   */
  rephrasedQuery = "";

  /**
   * @generated from field: string matched_agent_id = 6;
   */
  matchedAgentId = "";

  /**
   * @generated from field: bool is_prescribed_answer = 7;
   */
  isPrescribedAnswer = false;

  /**
   * @generated from field: string received_answer = 8;
   */
  receivedAnswer = "";

  constructor(data?: PartialMessage<EvalResponseData>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime = proto3;
  static readonly typeName = "context_engine.EvalResponseData";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    {
      no: 1,
      name: "matched_documents",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    {
      no: 2,
      name: "matched_messages",
      kind: "message",
      T: DocumentInfo,
      repeated: true,
    },
    {
      no: 3,
      name: "experiment_config",
      kind: "message",
      T: HandlerExperimentationConfigProto,
    },
    {
      no: 4,
      name: "selected_context",
      kind: "message",
      T: DocumentContextProto,
      repeated: true,
    },
    {
      no: 5,
      name: "rephrased_query",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 6,
      name: "matched_agent_id",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
    {
      no: 7,
      name: "is_prescribed_answer",
      kind: "scalar",
      T: 8 /* ScalarType.BOOL */,
    },
    {
      no: 8,
      name: "received_answer",
      kind: "scalar",
      T: 9 /* ScalarType.STRING */,
    },
  ]);

  static fromBinary(
    bytes: Uint8Array,
    options?: Partial<BinaryReadOptions>,
  ): EvalResponseData {
    return new EvalResponseData().fromBinary(bytes, options);
  }

  static fromJson(
    jsonValue: JsonValue,
    options?: Partial<JsonReadOptions>,
  ): EvalResponseData {
    return new EvalResponseData().fromJson(jsonValue, options);
  }

  static fromJsonString(
    jsonString: string,
    options?: Partial<JsonReadOptions>,
  ): EvalResponseData {
    return new EvalResponseData().fromJsonString(jsonString, options);
  }

  static equals(
    a: EvalResponseData | PlainMessage<EvalResponseData> | undefined,
    b: EvalResponseData | PlainMessage<EvalResponseData> | undefined,
  ): boolean {
    return proto3.util.equals(EvalResponseData, a, b);
  }
}
